import * as React from 'react';
import { ReferenceInput, SelectInput, SimpleForm, TextInput, FormDataConsumer, ReferenceArrayInput, SelectArrayInput, BooleanInput, ImageInput } from 'react-admin';
import { ToggleButtonGroup } from '@mui/material';
import { required, useTranslate } from 'ra-core';
import { RichTextInputToolbar, LevelSelect, ListButtons, LinkButtons, ClearButtons } from 'ra-input-rich-text';
import { ServiceImageField } from '../../components/Field/ServiceImageField';
import { CustomFormatButtons } from '../../components/FormatButtons';
import { HorizontalRuleButton } from '../../components/HorizontalRuleButton';
import { ImageButton } from '../../components/ImageButton';
import { LinkContentButton } from '../../components/LinkContentButton';
import { LinkFileButton } from '../../components/LinkFileButton';
import { VideoButton } from '../../components/VideoButton';
import { transformMediaUrlInput } from '../../lib/media/makeUrl';
import NewsResource from '../News/NewsResource';
import { isUrlValid } from '../../lib/media/isValidUrl';
import { RichTextInput } from '../../components/RichTextJsonInput';
import { withUpload } from '../../lib/withUpload';

let urlValid = false;

const urlExists = (url:string) => {
  if (url)
    return urlValid ? undefined : 'lto.generic.url_notfound';
  else 
    return undefined;
}

const rules = {
  name: [required()],
  imageurl: [required(), isUrlValid, urlExists],
  image: [required()],
};

export const RegionForm = (props: any) => {
  const translate = useTranslate()
  return (
    <SimpleForm defaultValues={withUpload('mediaId', 'media')}>
      <TextInput source="name" required />
      <ReferenceInput label="LTO" source="ltoId" reference="ltos">
        <SelectInput optionText="name" required />
      </ReferenceInput>
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          if (!formData.ltoId) {
            return null;
          }
          return (
            <ReferenceArrayInput
              source="departmentIds"
              reference="departments"
              perPage={99999}
              filter={{ ltos: [formData.ltoId] }}
              sort={{field: 'name', order: 'ASC'}}
            >
              <SelectArrayInput
                optionText="name"
                label={translate('resources.departments.name', { smart_count: 2 })}
              />
            </ReferenceArrayInput>
          )
        }}
      </FormDataConsumer>
      <BooleanInput source="isProvince" />
      <BooleanInput source="useMediaUrl" />
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          const displayurl = transformMediaUrlInput(formData.mediaUrl)
          return formData.useMediaUrl ? (
              <>
                <TextInput source="mediaUrl" placeholder='mediaUrl' validate={rules.imageurl} />
                {formData.mediaUrl ? <img style={{ marginBottom: '14px'}} onError={() => urlValid = false} onLoad={() => urlValid = true} src={`${displayurl}${displayurl.includes('?') ? '&' : '?'}width=48&height=48`} width={48} height={48} alt={formData.mediaUrl} /> : null}
              </>
            ) : (
              <ImageInput
                source="media"
                label={false}
                accept="image/png, image/jpeg, image/webp"
                validate={rules.image}
                placeholder={<p>{translate('lto.upload_label')}</p>}
                helperText={'resources.news.imageHelperText'}
              >
                <ServiceImageField source="media" sortable={false} />
              </ImageInput>
            )
          }
        }
      </FormDataConsumer>
      <RichTextInput
        source="content"
        contentType="json"
        toolbar={
          <RichTextInputToolbar>
            <LevelSelect />
            <HorizontalRuleButton />
            <CustomFormatButtons />
            <ListButtons />
            <ToggleButtonGroup>
              <LinkButtons />
              <LinkContentButton resource={NewsResource.name}  />
              <LinkFileButton allowed={['application/msword', 'application/msexcel', 'application/pdf', 'text/plain', 'application/vnd.ms-powerpoint']} />
            </ToggleButtonGroup>
            <ToggleButtonGroup>
              <ImageButton />
              <VideoButton />
            </ToggleButtonGroup>
            <ClearButtons />
          </RichTextInputToolbar>
        }
      />
    </SimpleForm>
  )
}
